/**
 * "Talk to us" pill (snippets/sunday-talk-pill.liquid, mockups v111 / home v125): shows once the
 * never-compressed band (#never) is well on screen, until the talk card (#help), while a page's sticky buy bar
 * ([data-bar].sd-on) is away; a tap opens Call and WhatsApp, a tap elsewhere closes them.
 */
const pill = document.querySelector('[data-tpill]');
if (pill) {
  const btn = pill.querySelector('[data-tpill-btn]');
  const box = pill.querySelector('[data-tpill-box]');
  const from = document.querySelector('#never');
  const to = document.querySelector('#help');
  let tick = 0;
  const check = () => {
    tick = 0;
    const vh = innerHeight;
    const past = !from || from.getBoundingClientRect().top + 200 < vh;
    const before = !to || to.getBoundingClientRect().top > vh - 60;
    const barOn = !!document.querySelector('[data-bar].sd-on');
    const on = btn.getAttribute('aria-expanded') === 'true' || (past && before && !barOn);
    pill.classList.toggle('sd-on', on);
    btn.tabIndex = on ? 0 : -1;
  };
  const ask = () => {
    if (!tick) tick = requestAnimationFrame(check);
  };
  const shut = () => {
    btn.setAttribute('aria-expanded', 'false');
    box.hidden = true;
    check();
  };
  addEventListener('scroll', ask, { passive: true });
  document.addEventListener('scroll', ask, { passive: true, capture: true });
  addEventListener('resize', ask);
  document.addEventListener('sunday:bar', ask);
  btn.addEventListener('click', () => {
    const open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', String(open));
    box.hidden = !open;
    check();
  });
  document.addEventListener('click', (e) => !box.hidden && !pill.contains(e.target) && shut());
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !box.hidden) {
      shut();
      btn.focus();
    }
  });
  check();
}
